<template>
  <div class="footer-cookie-notice-wrapper visible" id="CookieNotice">
    <button type="button" class="cookie-consent-overlay visible"></button>
    <div class="cookie-modal-dialog visible">
      <div class="cookie-modal-main">
        <div class="cookie-modal-main-content">
          <div class="cookie-modal-container">
            <div class="cookie-top-content">
              <h4 class="cookie-top-content-head">{{ t('cookies.settings') }}</h4>
              <p class="cookie-top-content-body">
                  <span v-html="t('cookies.notice.main', {params: [{shopname: eshopName, policyurl: policyUrl}]})"></span>
              </p>
            </div>
            <div class="cookie-bottom-content">
              <button class="cookie-bottom-content-accept-btn" data-action="consentToCookiesAll" @click="postCookieSettingsAll">
                <span>{{ t('cookies.accept') }}</span><i class="lni lni-checkmark"></i>
              </button>
              <button class="cookie-bottom-content-settings-btn" data-target="#CookieSettings" @click="openSettings">
                <span>{{ t('cookies.more') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieNotice',
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    openSettings () {
      this.$store.commit('openSettings')
    },
    postCookieSettingsAll () {
      this.$store.commit('updateCookieSettingsAll')
      this.$store.commit('postCookieSettings')
      this.hideModal()
    },
    hideModal () {
      this.$store.commit('hideModal')
    },
    eshopName () {
      return this.t('hct.eshop.name')
    },
    policyUrl () {
      return this.t('hct.eshop.policy.url')
    }
  }
}
</script>
